
<div class="row">
  <div class="col-md-6 col-sm-12">
    <div class="about-header">About Zaya</div>
    <p>
      At Zaya, we focus on supporting individuals seeking an integrated and holistic
      approach to support their mental health and physical wellbeing. We empower and
      enable people to have more control over the healthcare services they receive and
      become expert self-managers of their conditions.
      <br><br>
      We provide education, a trustworthy network of holistic health practitioners &
      therapists to empower you to create your personalised care experience.
      We believe that holistic and mind-body approaches allow us to go deeper than
      disease-focused care. By implementing these modalities into our lives we can start
      to learn how to tune into the core needs of our mental, emotional, physical and
      spiritual wellbeing.
    </p>
  </div>
  <div class="col-md-6 col-sm-12">
    <div class="image-container d-flex flex-fill justify-content-end">
      <div class="backdrop"></div>
      <img src="../../assets/images/zaya-home-banner.jpeg" alt="zaya home" height="450">
    </div>
  </div>
</div>
